export default "__VITE_ASSET__CooPwCKP__"